import { clamp } from "@opendaw/lib-std";
export const migrateRevampDeviceBox = (boxGraph, box) => {
    boxGraph.beginTransaction();
    box.lowPass.order.setValue(clamp(box.lowPass.order.getValue(), 0, 3));
    box.highPass.order.setValue(clamp(box.highPass.order.getValue(), 0, 3));
    boxGraph.endTransaction();
};
